import * as React from 'react';

const SelectContext = React.createContext({});

export { SelectContext };
